import { useMemo } from "react";
import { useRouter } from "next/router";

const useIsWebView = () => {
	const router = useRouter();

	const isWebView = useMemo(() => {
		const client = router?.query?.client;
		if (Array.isArray(client)) {
			return client.includes("android");
		}
		return client === "android";
	}, [router.query, router.isReady]);

	return (
		isWebView ||
		(typeof window !== "undefined" ? Boolean((window as any)?.appInterface) : false)
	);
};

export default useIsWebView;
